export default ({ COLORS, FONT_SIZES }) => ({
  container: {
    textAlign: 'center',
    ...FONT_SIZES.BODY_LARGE.STYLE
  },
  cancel: {
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold',
    cursor: 'pointer'
  }
})
